import { createSlice } from "@reduxjs/toolkit";
const initialState={
  isdownloading:false,
  percentage:0
}
export const Downloader = createSlice({
  name: "downloader",
  initialState: initialState,
  reducers: {
    showDownloader: (state ,action) => {
        state.isdownloading=action.payload.isdownloading 
    },  
    showPercentage: (state ,action) => {
        state.percentage=action.payload.percentage 
    },  
  },
});

// Action creators are generated for each case reducer function
export const {showDownloader,showPercentage} = Downloader.actions;

export default Downloader.reducer;


